import React, { Component } from 'react';
import Panel from './shared/Panel';
import PeriodSelector from './shared/PeriodSelector';
import ContractTxnVolumeChart from './containers/ContractTxnVolumeChart';
import Info from './shared/Info';
import { parseQueryParams } from  '../utils';
import { withRouter } from 'react-router-dom';
import Share from './shared/Share';
export class ContractTxnVolumeChartPanel extends Component {
	state = {
		period: '1W',
		contractId: ''
	};

	componentDidMount() {
		const params = parseQueryParams(this.props.location.search);
		if(params && params.period) {
			this.setState({
					period: params.period,
			});
		}
	}

	onPeriodSelect = (e, { value }) => {
		this.setState({ period: value });
	};

	sendContractIdparam = (id) => {
		this.setState({contractId : id})
	}

	render() {
		const { period } = this.state;
		let url = `/chart?name=contract-txn-vol&period=${this.state.period}&contractId=${this.state.contractId}`;
		const params = parseQueryParams(this.props.location.search);
		return (
			<Panel
				title={
					<React.Fragment>
						TRANSACTION VOLUME <Info id="txVolume" />
					</React.Fragment>
				}
				titleClass="light"
				description=""
				footer={<Share url={url} params={params} title={"Dragon Glass Contract Transaction Volume Chart"}/>}
				toolbar={<PeriodSelector value={period} onSelect={this.onPeriodSelect} />}
			>
				<ContractTxnVolumeChart period={period} sendContractIdparam={this.sendContractIdparam}/>
			</Panel>
		);
	}
}

export default withRouter(ContractTxnVolumeChartPanel);
